import core from './commuCore'
const output = {}

/* —————————————————————— 厂牌相关api —————————————————————— */

function reqGetApplyPage (team) {
  return core.ajax(team, '/apply/page', 'get')
}
output.reqGetApplyPage = reqGetApplyPage

function applyReport (team) {
  return core.ajax(team, '/apply', 'post')
}
output.applyReport = applyReport

function reqGetApplyCounts (team) {
  return core.ajax(team, '/apply/applyCounts', 'get')
}
output.reqGetApplyCounts = reqGetApplyCounts

// 获取下载原稿数据
function getReportPage (data) {
  return core.ajax(data, '/apply/getReportPage', 'get')
}
output.getReportPage = getReportPage

// 获取用户统计数据
function reqGetApplyStatistics (team) {
  return core.ajax(team, '/apply/statistics', 'get')
}
output.reqGetApplyStatistics = reqGetApplyStatistics

// 导出申请记录Excel
function exportApplyRecords (team) {
  return core.ajax(team, '/apply/export/records', 'get')
}
output.exportApplyRecords = exportApplyRecords

// 导出用户统计Excel
function exportApplyStatistics (team) {
  return core.ajax(team, '/apply/export/statistics', 'get')
}
output.exportApplyStatistics = exportApplyStatistics

export default output
